var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedPost)?_c('div',[_c('transition',{attrs:{"name":"reouter-anim","duration":{enter: 800, leave: 300},"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut","mode":"out-in"}},[_c('PostShow',{key:this.$route.params.slug,style:(_vm.getZoomByScreen()),attrs:{"post":_vm.selectedPost}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }